import { render, staticRenderFns } from "./ManualOrder.vue?vue&type=template&id=9c70a5b0&scoped=true&"
import script from "./ManualOrder.vue?vue&type=script&lang=ts&"
export * from "./ManualOrder.vue?vue&type=script&lang=ts&"
import style0 from "./ManualOrder.vue?vue&type=style&index=0&id=9c70a5b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c70a5b0",
  null
  
)

export default component.exports